module.exports = __webpack_public_path__ + "media/images/map/map-cluster-b656008cd405c8845b218b747efbfa32.png";